import { FIELD_TYPES, NOW_VALUE } from '../constants';
import { dateToDateString, dateToTimeString } from '../field-rule/inputs/utils';
export const DEFAULT_VALUE = {
  [FIELD_TYPES.TEXT_INPUT]: resolveDefaultValue,
  [FIELD_TYPES.CHECKBOX_GROUP]: resolveDefaultValue,
  [FIELD_TYPES.RADIO_GROUP]: resolveDefaultValue,
  [FIELD_TYPES.DROPDOWN]: resolveDefaultValue,
  [FIELD_TYPES.URL_INPUT]: resolveDefaultValue,
  [FIELD_TYPES.NUMBER_INPUT]: resolveDefaultValue,
  [FIELD_TYPES.CHALLENGES_NUMBER]: resolveDefaultValue,
  [FIELD_TYPES.CHALLENGES_SHORT_TEXT]: resolveDefaultValue,
  [FIELD_TYPES.CHALLENGES_LONG_TEXT]: resolveDefaultValue,
  [FIELD_TYPES.CHALLENGES_MULTI_CHOICE]: resolveDefaultValue,
  [FIELD_TYPES.CHALLENGES_IMAGE_CHOICE]: resolveDefaultValue,
  [FIELD_TYPES.CHALLENGES_SINGLE_CHOICE]: resolveDefaultValue,
  [FIELD_TYPES.CHALLENGES_FILE_UPLOAD]: resolveDefaultValue,
  [FIELD_TYPES.QUIZ_SHORT_TEXT]: resolveDefaultValue,
  [FIELD_TYPES.QUIZ_NUMBER]: resolveDefaultValue,
  [FIELD_TYPES.IMAGE_CHOICE]: resolveDefaultValue,
  [FIELD_TYPES.FILE_UPLOAD]: resolveDefaultValue,
  [FIELD_TYPES.SIGNATURE]: resolveDefaultValue,
  [FIELD_TYPES.CONTACTS_EMAIL]: resolveDefaultValue,
  [FIELD_TYPES.CONTACTS_PHONE]: resolveDefaultValue,
  [FIELD_TYPES.CHECKBOX]: resolveDefaultValue,
  [FIELD_TYPES.DATE_TIME_INPUT]: resolveDefaultValue,
  [FIELD_TYPES.CONTACTS_COMPANY]: resolveDefaultValue,
  [FIELD_TYPES.CONTACTS_POSITION]: resolveDefaultValue,
  [FIELD_TYPES.CONTACTS_TAX_ID]: resolveDefaultValue,
  [FIELD_TYPES.CONTACTS_FIRST_NAME]: resolveDefaultValue,
  [FIELD_TYPES.CONTACTS_LAST_NAME]: resolveDefaultValue,
  [FIELD_TYPES.CONTACTS_ADDRESS]: resolveDefaultValue,
  [FIELD_TYPES.CONTACTS_BIRTHDATE]: resolveDefaultValue,
  [FIELD_TYPES.TEXT_AREA]: resolveDefaultValue,
  [FIELD_TYPES.CONTACTS_SUBSCRIBE]: resolveDefaultValue,
  [FIELD_TYPES.DATE_INPUT]: resolveDefaultValue,
  [FIELD_TYPES.TIME_INPUT]: resolveDefaultTimeValue,
  [FIELD_TYPES.DATE_PICKER]: resolveDefaultDateValue,
  [FIELD_TYPES.NESTED_FORM]: resolveDefaultValue,
  [FIELD_TYPES.MULTILINE_ADDRESS]: resolveDefaultValue,
  [FIELD_TYPES.MLA_COUNTRY]: resolveDefaultValue,
  [FIELD_TYPES.MLA_CITY]: resolveDefaultValue,
  [FIELD_TYPES.MLA_ADDRESS_LINE]: resolveDefaultValue,
  [FIELD_TYPES.MLA_ADDRESS_LINE_2]: resolveDefaultValue,
  [FIELD_TYPES.MLA_POSTAL_CODE]: resolveDefaultValue,
  [FIELD_TYPES.MLA_SUBDIVISION]: resolveDefaultValue,
  [FIELD_TYPES.MLA_STREET_NAME]: resolveDefaultValue,
  [FIELD_TYPES.MLA_STREET_NUMBER]: resolveDefaultValue,
  [FIELD_TYPES.MLA_APARTMENT]: resolveDefaultValue,
  [FIELD_TYPES.FULL_NAME]: resolveDefaultValue,
  [FIELD_TYPES.FULL_NAME_FIRST_NAME]: resolveDefaultValue,
  [FIELD_TYPES.FULL_NAME_LAST_NAME]: resolveDefaultValue,
  [FIELD_TYPES.VAT_ID]: resolveDefaultValue,
  [FIELD_TYPES.DEXT_TEXT_INPUT]: resolveDefaultValue,
  [FIELD_TYPES.DEXT_NUMBER_INPUT]: resolveDefaultValue,
  [FIELD_TYPES.DEXT_CHECKBOX]: resolveDefaultValue,
  [FIELD_TYPES.DEXT_CHECKBOX_GROUP]: resolveDefaultValue,
  [FIELD_TYPES.DEXT_RATING_INPUT]: resolveDefaultValue,
  [FIELD_TYPES.DEXT_TAGS]: resolveDefaultValue,
  [FIELD_TYPES.ECOM_ADDITIONAL_INFO]: resolveDefaultValue,
  [FIELD_TYPES.ECOM_ADDRESS]: resolveDefaultValue,
  [FIELD_TYPES.ECOM_PHONE]: resolveDefaultValue,
  [FIELD_TYPES.ECOM_FULL_NAME]: resolveDefaultValue,
  [FIELD_TYPES.ECOM_COMPANY_NAME]: resolveDefaultValue,
  [FIELD_TYPES.ECOM_SUBSCRIPTION]: resolveDefaultValue,
  [FIELD_TYPES.ECOM_EMAIL]: resolveDefaultValue,
  [FIELD_TYPES.DEXT_TEXT_AREA]: resolveDefaultValue,
  [FIELD_TYPES.DEXT_DROPDOWN]: resolveDefaultValue,
  [FIELD_TYPES.DEXT_RADIO_GROUP]: resolveDefaultValue,
  [FIELD_TYPES.DEXT_URL_INPUT]: resolveDefaultValue,
  [FIELD_TYPES.DEXT_EMAIL]: resolveDefaultValue,
  [FIELD_TYPES.DEXT_PHONE]: resolveDefaultValue,
  [FIELD_TYPES.DEXT_DATE_PICKER]: resolveDefaultValue,
  [FIELD_TYPES.DEXT_DATE_TIME_INPUT]: resolveDefaultValue,
  [FIELD_TYPES.PRODUCT_LIST]: resolveDefaultValue,
  [FIELD_TYPES.DONATION]: resolveDefaultValue,
  [FIELD_TYPES.RATING_INPUT]: resolveDefaultValue,
  [FIELD_TYPES.TAGS]: resolveDefaultValue,
  [FIELD_TYPES.PAYMENT_INPUT]: resolveDefaultValue,
  [FIELD_TYPES.FIXED_PAYMENT]: resolveDefaultValue,
  [FIELD_TYPES.BOOKINGS_FIRST_NAME]: resolveDefaultValue,
  [FIELD_TYPES.BOOKINGS_LAST_NAME]: resolveDefaultValue,
  [FIELD_TYPES.BOOKINGS_EMAIL]: resolveDefaultValue,
  [FIELD_TYPES.BOOKINGS_PHONE]: resolveDefaultValue,
  [FIELD_TYPES.BOOKINGS_ADDRESS]: resolveDefaultValue,
  [FIELD_TYPES.APPOINTMENT]: resolveDefaultValue,
  [FIELD_TYPES.PASSWORD]: resolveDefaultValue,
  [FIELD_TYPES.SERVICES_DROPDOWN]: resolveDefaultValue,
  [FIELD_TYPES.SERVICES_MULTI_CHOICE]: resolveDefaultValue,
  [FIELD_TYPES.EVENTS_RSVP]: resolveDefaultValue,
  [FIELD_TYPES.EVENTS_REPEATER]: resolveDefaultValue,
  [FIELD_TYPES.PHONE]: resolveDefaultValue
};
function resolveDefaultValue(field) {
  var _field$view;
  return (_field$view = field.view) == null ? void 0 : _field$view.defaultValue;
}
function resolveDefaultDateValue(field) {
  var _field$view2;
  const defaultValue = (_field$view2 = field.view) == null ? void 0 : _field$view2.defaultValue;
  if (defaultValue === NOW_VALUE) {
    return dateToDateString(new Date());
  }
  return defaultValue;
}
function resolveDefaultTimeValue(field) {
  var _field$view3;
  const defaultValue = (_field$view3 = field.view) == null ? void 0 : _field$view3.defaultValue;
  if (defaultValue === NOW_VALUE) {
    return dateToTimeString(new Date());
  }
  return defaultValue;
}
//# sourceMappingURL=normalize-default-value.js.map